// frontend/src/api/admin.js
import { apiClient } from './index';

const adminApi = {
  /**
   * Get dashboard statistics (Cards)
   */
  getDashboardStats: async () => {
    return await apiClient.get('/admin/stats');
  },

  /**
   * Get analytics data for Dashboard charts (Simple)
   */
  getAnalyticsData: async () => {
    return await apiClient.get('/admin/analytics');
  },

  /**
   * Get DEEP analytics data for Reports Page (Complex)
   */
  getDeepAnalytics: async () => {
    return await apiClient.get('/analytics/deep-report');
  },

  /**
   * Log a search query (Public)
   */
  logSearch: async (query, resultsCount) => {
    return await apiClient.post('/analytics/log-search', { 
        query, 
        results_count: resultsCount 
    });
  },

  /**
   * Get System Health Status (DB, APIs)
   */
  getSystemHealth: async () => {
    return await apiClient.get('/admin/health');
  },

  /**
   * Get Admin Audit Logs
   */
  getAuditLogs: async () => {
    return await apiClient.get('/admin/audit-logs');
  }
};

export { adminApi };